/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompleteMultipartUploadRequest } from '../models/CompleteMultipartUploadRequest';
import type { CreateFileUploadPayload } from '../models/CreateFileUploadPayload';
import type { FileWithUrl_Input } from '../models/FileWithUrl_Input';
import type { FileWithUrl_Output } from '../models/FileWithUrl_Output';
import type { GeneratePresignedUrlsRequest } from '../models/GeneratePresignedUrlsRequest';
import type { PresignedUrlsResponse } from '../models/PresignedUrlsResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class FilesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Create File Upload
     * @param requestBody
     * @param identityService
     * @returns any Successful Response
     * @throws ApiError
     */
    public createFileUpload(
        requestBody: CreateFileUploadPayload,
        identityService?: any,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/files/upload',
            query: {
                'identity_service': identityService,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Multipart Upload
     * @param requestBody
     * @param identityService
     * @returns any Successful Response
     * @throws ApiError
     */
    public createMultipartUpload(
        requestBody: CreateFileUploadPayload,
        identityService?: any,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/files/multipart/init',
            query: {
                'identity_service': identityService,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Generate Presigned Urls For Parts
     * @param requestBody
     * @param identityService
     * @returns PresignedUrlsResponse Successful Response
     * @throws ApiError
     */
    public generatePresignedUrlsForParts(
        requestBody: GeneratePresignedUrlsRequest,
        identityService?: any,
    ): CancelablePromise<PresignedUrlsResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/files/multipart/parts',
            query: {
                'identity_service': identityService,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Complete Multipart Upload
     * @param requestBody
     * @param identityService
     * @returns any Successful Response
     * @throws ApiError
     */
    public completeMultipartUpload(
        requestBody: CompleteMultipartUploadRequest,
        identityService?: any,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/files/multipart/complete',
            query: {
                'identity_service': identityService,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete File
     * @param fileId
     * @param identityService
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteFile(
        fileId: string,
        identityService?: any,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/files/delete-file/{file_id}',
            path: {
                'file_id': fileId,
            },
            query: {
                'identity_service': identityService,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Files For Ids
     * @param requestBody
     * @param identityService
     * @returns FileWithUrl_Input Successful Response
     * @throws ApiError
     */
    public listFilesForIds(
        requestBody: Array<string>,
        identityService?: any,
    ): CancelablePromise<Array<FileWithUrl_Input>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/files/list-files-for-ids',
            query: {
                'identity_service': identityService,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get File With Url
     * @param fileId
     * @param identityService
     * @returns FileWithUrl_Output Successful Response
     * @throws ApiError
     */
    public getFileWithUrl(
        fileId: string,
        identityService?: any,
    ): CancelablePromise<FileWithUrl_Output> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/files/get-file-with-url/{file_id}',
            path: {
                'file_id': fileId,
            },
            query: {
                'identity_service': identityService,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
